import noop from 'lodash/noop';
import { useRouter } from 'next/router';
import React, {
  MutableRefObject,
  useCallback,
  useContext,
  useEffect,
  useRef,
} from 'react';

interface IPdpScrollContextState {
  refValue: MutableRefObject<HTMLDivElement>;
  scroll: () => void;
}

const PdpScrollContext = React.createContext<IPdpScrollContextState>({
  refValue: undefined,
  scroll: noop,
});

export const PdpScrollContextProvider: React.FC = ({ children }) => {
  const { asPath } = useRouter();
  const refValue = useRef<HTMLDivElement>();
  const targetOffsetTop = refValue.current?.offsetTop;

  const scroll = useCallback(() => {
    if (typeof targetOffsetTop === 'number') {
      window.scrollTo({
        top: targetOffsetTop,
        left: 0,
        behavior: 'smooth',
      });
    }
  }, [targetOffsetTop]);

  useEffect(() => {
    const offersHash = asPath.match(/#offers/gi) != null;
    if (offersHash) {
      scroll();
    }
  }, [asPath, refValue, scroll]);

  return (
    <PdpScrollContext.Provider value={{ refValue, scroll }}>
      {children}
    </PdpScrollContext.Provider>
  );
};

export function usePdpScrollContext() {
  return useContext(PdpScrollContext);
}
